import { render } from "./SwitchTeacherModal.vue?vue&type=template&id=4e652efc"
import script from "./SwitchTeacherModal.vue?vue&type=script&lang=js"
export * from "./SwitchTeacherModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SwitchTeacherModal.vue?vue&type=style&index=0&id=4e652efc&lang=scss&module=true"
cssModules["$style"] = style0
import "./SwitchTeacherModal.vue?vue&type=style&index=1&id=4e652efc&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__